import { Injectable } from '@angular/core';

import './../../shared/rxjs-operators';
import { LogService, ApiService, CacheService, AppContext } from './../../shared';

@Injectable()
export class EmailBoxService {
  email: string = '';
  emailError: string = '';
  items: Array<string> = [];

  constructor(private logger: LogService, private api: ApiService, private cache: CacheService, public app: AppContext) {
  }

  add() {
    this.email = this.parse(this.email);
    if (this.email !== '') {
      this.emailError = 'Invalid Email';
    }
  }

  parse(emails: string): string {
    try {
      if (emails === null || emails === undefined || emails === '') {
        return '';
      }

      if (this.isEmail(emails)) {
        this.items.push(emails);
        return '';
      }

      let indexOfSpace = emails.indexOf(' ');
      let indexOfComma = emails.indexOf(',');
      let index = Math.min(indexOfSpace, indexOfComma) === -1 ? Math.max(indexOfSpace, indexOfComma) : Math.min(indexOfSpace, indexOfComma);

      if (index === -1) {
        return emails;
      } else if (index === 0) {
        return this.parse(emails.slice(1));
      }

      let mightBeEmail = emails.substr(0, index);

      if (this.isEmail(mightBeEmail)) {
        this.items.push(mightBeEmail);
        return this.parse(emails.substr(index));
      } else {
        return emails;
      }
    } catch (ex) {
      return '';
    }
  }

  isEmail(email) {
    return /^([^\x00-\x20\x22\x28\x29\x2c\x2e\x3a-\x3c\x3e\x40\x5b-\x5d\x7f-\xff]+|\x22([^\x0d\x22\x5c\x80-\xff]|\x5c[\x00-\x7f])*\x22)(\x2e([^\x00-\x20\x22\x28\x29\x2c\x2e\x3a-\x3c\x3e\x40\x5b-\x5d\x7f-\xff]+|\x22([^\x0d\x22\x5c\x80-\xff]|\x5c[\x00-\x7f])*\x22))*\x40([^\x00-\x20\x22\x28\x29\x2c\x2e\x3a-\x3c\x3e\x40\x5b-\x5d\x7f-\xff]+|\x5b([^\x0d\x5b-\x5d\x80-\xff]|\x5c[\x00-\x7f])*\x5d)(\x2e([^\x00-\x20\x22\x28\x29\x2c\x2e\x3a-\x3c\x3e\x40\x5b-\x5d\x7f-\xff]+|\x5b([^\x0d\x5b-\x5d\x80-\xff]|\x5c[\x00-\x7f])*\x5d))*$/.test(email);
  }

  remove(index: string) {
    // remove from list
    this.items.splice(+index, 1);
  }
}



// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/shared/email-box/email-box.service.ts